import Head from 'next/head';

import useI18n from '@i18n';

// Components
import BlockBackit from '@components/pages/cpa/epnbz/BlockBackit';
import Header from '@components/pages/cpa/epnbz/BlockHeader';
import BlockNetwork from '@components/pages/cpa/epnbz/BlockNetwork';
import BlockOurStrength from '@components/pages/cpa/epnbz/BlockOurStrength';
import BlockSeo from '@components/pages/cpa/epnbz/BlockSeo';
import BlockTraffics from '@components/pages/cpa/epnbz/BlockTraffics';
import BlockOurPartners from '@components/pages/home/epnbz/BlockOurPartners';
import BlockStats from '@components/pages/home/epnbz/BlockStats';
import useRefreshToken from '@hooks/useRefreshToken';

const WebmasterNew: React.FC = () => {
    const { t, locale } = useI18n('Cpa');
    const formLink = `/${locale}/cpa/apply`;
    const isAuth = useRefreshToken();
    return (
        <>
            <Head>
                <title>{t('CPA: what is it in marketing (in simple words)')}</title>
                <meta
                    name="description"
                    content={t(
                        'In simple terms, we explained what CPA is in marketing and advertising...',
                    )}
                />
            </Head>
            <main className="pb-[179px] xs:pb-[200px]">
                <Header formLink={formLink} />
                <BlockStats />
                <BlockNetwork />
                <BlockTraffics />
                {isAuth && <BlockOurPartners />}
                <BlockOurStrength />
                <BlockBackit />
                <BlockSeo locale={locale} />
            </main>
        </>
    );
};

export default WebmasterNew;
